import Image from "next/image";

interface FlexiSmartBannerProps {
  banner?: string;
  icon?: string;
  title: string;
  subtitle: string;
}

export default function FlexiSmartBanner({
  banner,
  icon,
  title,
  subtitle,
}: Readonly<FlexiSmartBannerProps>) {
  return (
    <div
      className="relative w-full overflow-hidden rounded-t-xl"
      data-testid="flexi-smart-banner-section"
    >
      <div className="absolute inset-0">
        {banner && <Image src={banner} alt={`${title} background`} fill priority />}
      </div>

      <div className="relative z-10 flex items-center gap-4 p-6">
        {icon && (
          <Image src={icon} width={50} height={50} alt={`${title} icon`} className="shrink" />
        )}
        <div className="flex flex-col space-y-2">
          <span className="px-3 py-1 text-xl font-bold text-white rounded bg-brand-blue w-fit">
            {title}
          </span>
          <p className="text-sm font-medium tracking-wide text-white uppercase">
            {subtitle.toUpperCase()}
          </p>
        </div>
      </div>
    </div>
  );
}
